import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Box } from "@mui/material";
import { getCargos, getResponsables, newResponsable, } from "../../../../redux/actions/empleador";
import { saveResponsableForm } from "../../../../redux/actions/nte";
import DataLabel from "../../../commons/labels/DataLabel";
import FechaPresentacionLabel from "../../../commons/planillas/FechaPresentacionLabel";
import NewResponsableDialog from "../../../commons/responsables/dialog/NewResponsableDialog";
import ResponsablesForm from "./forms/ResponsablesForm";

const initialValues = {
  responsableDeDatos: "",
  responsableDeSeguridad: "",
};

const ResponsablesContainer = ({ nextForm }) => {
  const dispatch = useDispatch();

  const datosEstablecimiento = useSelector((state) => state.nte.datosEstablecimiento);
  const obligatoriaResponsableSH = useSelector((state) => state.nte.obligatoriedadResponsable);
  const responsablesFormRedux = useSelector((state) => state.nte.postNte.responsablesForm);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [formModel, setFormModel] = useState(null);
  const [respDatosState, setRespDatos] = useState(false);
  const [responsableType, setResponsableType] = useState(null);
  const [isDatos, setIsDatos] = useState(false);

  const isLoading =
    !formModel ||
    datosEstablecimiento.loading ||
    obligatoriaResponsableSH.loading ||
    obligatoriaResponsableSH.data === null;

  useEffect(() => {
    setFormModel({
      ...initialValues,
      responsableDeDatos:
        responsablesFormRedux?.responsableDeDatos ??
        initialValues.responsableDeDatos,
      responsableDeSeguridad:
        responsablesFormRedux?.responsableDeSeguridad ??
        initialValues.responsableDeSeguridad,
    });
  }, []);

  const handleCloseResponsableDialog = () => {
    setDialogOpen(false);
  };

  const handleAddResponsable = (values) => {
    dispatch(newResponsable(values)).then((resp) => {
      toast.success("Responsable agregado correctamente");
      dispatch(getResponsables(responsableType, isDatos)).then((res) => {
        let objAux = {
          id: res.value.data[res.value.data.length - 1].id,
          nombre: res.value.data[res.value.data.length - 1].nombre,
        };
        setFormModel({
          ...formModel,
          [respDatosState]: objAux.id,
        });
        setDialogOpen(false);
      });
    });
  };

  const handleOpenDialog = (respDatos, cu, isDatos) => {
    setIsDatos(isDatos);
    setRespDatos(respDatos);
    setResponsableType(cu);
    dispatch(getCargos(cu))
    setDialogOpen(true);
  };

  const handleSubmitForm = (values) => {
    dispatch(saveResponsableForm(values));
    nextForm("ImportarNóminas");
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <DataLabel
          firstText={"MU: " + datosEstablecimiento.data?.matrizUnica}
          secondText={datosEstablecimiento.data?.nombre?.split("-")[0]}
          thirdText={datosEstablecimiento.data?.domicilio}
        />
      </Box>
      <Box sx={{ marginTop: "10px" }}>
        <FechaPresentacionLabel />
      </Box>
      <Box sx={{ margin: "10px" }}>
        <ResponsablesForm
          model={formModel}
          handleSubmit={handleSubmitForm}
          handleOpenDialog={handleOpenDialog}
          isLoading={isLoading}
          isResponsableSHRequired={Boolean(obligatoriaResponsableSH.data)}
        />
      </Box>
      <NewResponsableDialog
        open={dialogOpen}
        handleSubmit={handleAddResponsable}
        handleClose={handleCloseResponsableDialog}
        isResponsableDatos={isDatos}
      />
    </Box>
  );
};

export default ResponsablesContainer;
